import {
   Box,
   CircularProgress,
   Container,
   Divider,
   Paper,
   Typography,
} from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { withFirebase } from '../../Firebase';
import CarReg from './carReg';
import ContactNumber from './contactNumber';
import VisitorDetails from './visitorDetails';
import VisitorMeeting from './visitorMeeting';
import VisitorMeetingConfirm from './visitorMeetingConfirm';
import VisitorPass from './visitorPass';

const VisitorForm = ({ customisations, contractor, ...props }) => {
   const history = useHistory();
   const [status, setStatus] = useState(null);
   const [form, setForm] = useState(false);
   const [host, setHost] = useState(false);
   const [imageUrl, setImageUrl] = useState(null);
   const [visitorOptions, setVisitorOptions] = useState(null);
   const [selectedContractor, setSelectedContractor] = useState(null);

   const [confirmed, setConfirmed] = useState(() => {
      if (customisations !== null && customisations.confirmationStatements?.length > 0) {
         return false;
      } else {
         return true;
      }
   });

   useEffect(() => {
      const fetchImage = async () => {
         if (props.location) {
            const visitorDoc = await props.firebase.db
               .doc(`visitors/${props.location.loc}`)
               .get();
            if (visitorDoc.exists) {
               setVisitorOptions(visitorDoc.data());
            }
            if (visitorDoc.exists && visitorDoc.data().logoPath) {
               const fullPath = await props.firebase
                  .showImage(visitorDoc.data().logoPath)
                  .getDownloadURL();
               setImageUrl(fullPath);
            }
         }
      };
      fetchImage();
      return () => {
         setImageUrl(null);
      };
   }, [props.location]);

   useEffect(() => {
      if (props.location) {
         setStatus('step1');
      }
   }, [props.location]);

   const inactivityTimer = useRef(null);

   const resetTimer = () => {
      clearTimeout(inactivityTimer.current);
      inactivityTimer.current = setTimeout(clearForm, 30000); // 30 seconds
   };
   useEffect(() => {
      window.onload = resetTimer;
      document.onmousemove = resetTimer;
      document.onkeydown = resetTimer;
      document.ontouchstart = resetTimer; // For touch devices

      return () => {
         clearTimeout(inactivityTimer.current);
         window.onload = null;
         document.onmousemove = null;
         document.onkeydown = null;
         document.ontouchstart = null;
      };
   }, []);

   function clearForm() {
      if (props.llid) {
         setSelectedContractor(null);
         setForm(false);
         history.push({
            pathname: `/visitors?llid=${props.llid}&llocation=${props.landlocation}`,
         });
         history.go(0);
      } else {
         setSelectedContractor(null);
         setForm(false);
         history.go(0);
      }
      return;
   }
   function goBack() {
      if (status === 'step1' && props.llid) {
         setSelectedContractor(null);
         setForm(false);
         history.push({
            pathname: `/visitors?llid=${props.llid}&llocation=${props.landlocation}`,
         });
         history.go(0);
      } else if (status === 'step2' && customisations?.visitorPass) {
         setStatus('visitorPass');
      } else if (status === 'step2' && customisations?.contactNumber) {
         setStatus('contactNumber');
      } else if (status === 'step2' && customisations?.carReg) {
         setStatus('carReg');
      } else if (status === 'step2' && host?.found) {
         setHost({ found: false, name: '', email: '' });
      } else {
         setSelectedContractor(null);
         setStatus('step1');
      }
      return;
   }

   return (
      <>
         <Container component="main" sx={{ width: '70vw' }}>
            <Paper
               sx={{
                  mt: 6,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  p: 4,
               }}
            >
               {imageUrl !== null ? (
                  <Box
                     sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        flexDirection: 'column',
                     }}
                  >
                     <img
                        style={{
                           maxWidth: '100%',
                           maxHeight: '100px',
                           width: 'auto',
                           height: 'auto',
                        }}
                        src={imageUrl}
                     />
                     <Typography variant="h4" component="h1" align="center" gutterBottom>
                        {contractor ? 'Contractor ' : 'Visitor '} Registration
                     </Typography>
                  </Box>
               ) : (
                  <Typography variant="h4" component="h1" align="center" gutterBottom>
                     {props.location.locName} Visitor Registration
                  </Typography>
               )}

               <Divider style={{ width: '100%', marginBottom: '8px' }} />
               {status == 'step1' ? (
                  <VisitorDetails
                     setForm={setForm}
                     form={form}
                     setStatus={setStatus}
                     status={status}
                     lid={props.location.loc}
                     llid={props.location.llid || false}
                     landlocation={props.landlocation}
                     clearForm={clearForm}
                     goBack={goBack}
                     customisations={customisations}
                     contractor={contractor}
                     setSelectedContractor={setSelectedContractor}
                     selectedContractor={selectedContractor}
                  />
               ) : status == 'step2' ? (
                  <VisitorMeeting
                     form={form}
                     host={host}
                     setHost={setHost}
                     setForm={setForm}
                     status={status}
                     setStatus={setStatus}
                     lid={props.location.loc}
                     llid={props.location.llid || false}
                     landlocation={props.landlocation}
                     clearForm={clearForm}
                     goBack={goBack}
                     customisations={customisations}
                     locationName={props.location.locName}
                     visitorOptions={visitorOptions}
                     confirmed={confirmed}
                     setConfirmed={setConfirmed}
                     contractor={contractor}
                     selectedContractor={selectedContractor}
                  />
               ) : status == 'step3' ? (
                  <VisitorMeetingConfirm clearForm={clearForm} />
               ) : status == 'carReg' ? (
                  <CarReg
                     form={form}
                     setForm={setForm}
                     setStatus={setStatus}
                     lid={props.location.loc}
                     llid={props.location.llid || false}
                     landlocation={props.landlocation}
                     clearForm={clearForm}
                     customisations={customisations}
                  />
               ) : status == 'contactNumber' ? (
                  <ContactNumber
                     form={form}
                     setForm={setForm}
                     setStatus={setStatus}
                     lid={props.location.loc}
                     llid={props.location.llid || false}
                     landlocation={props.landlocation}
                     clearForm={clearForm}
                     customisations={customisations}
                  />
               ) : status == 'visitorPass' ? (
                  <VisitorPass
                     form={form}
                     setForm={setForm}
                     setStatus={setStatus}
                     lid={props.location.loc}
                     llid={props.location.llid || false}
                     landlocation={props.landlocation}
                     clearForm={clearForm}
                     customisations={customisations}
                  />
               ) : (
                  <Box
                     display="flex"
                     justifyContent="center"
                     alignItems="center"
                     height="100vh"
                     flexDirection="column"
                  >
                     <Typography variant="h5" component="h2" paragraph>
                        Loading...
                     </Typography>
                     <CircularProgress />
                  </Box>
               )}
            </Paper>
         </Container>
      </>
   );
};

export default withFirebase(VisitorForm);
